var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['vuetable-pagination-info', _vm.css.infoClass],domProps:{"innerHTML":_vm._s(_vm.paginationInfo)}})
}
var staticRenderFns = []

export { render, staticRenderFns }